"use-strict";
var BlsLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const onImageLoad = (e) => {
                  const target = e.currentTarget;
                  setTimeout(() => {
                    target
                      ?.closest("motion-element")
                      ?.classList.remove("bls-loading-image");
                    target?.classList.remove("bls-loading-image");
                  }, 600);
                  e.currentTarget.removeEventListener("load", onImageLoad);
                };
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                entry.target.sizes = `${entry.boundingClientRect.width}px`;
                entry.target.addEventListener("load", onImageLoad);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "10px" }
        );
        document.querySelectorAll(".bls-image-js img").forEach((img) => {
          observer.observe(img);
        });
      }
    },
  };
})();
BlsLazyloadImg.init();
function CloseAllPopup(data) {
  publish("closeCanvas", data);
}

const imageReady = (imageOrArray) => {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray =
    imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(
    imageOrArray.map((image) => {
      return new Promise((resolve) => {
        if (
          (image.tagName === "IMG" && image.complete) ||
          !image.offsetParent
        ) {
          setTimeout(() => {
            image
              .closest("motion-element")
              ?.classList.remove("bls-loading-image");
            image.classList.remove("bls-loading-image");
            resolve();
          }, 100);
        } else {
          image.addEventListener("load", (e) => {
            e.currentTarget
              .closest("motion-element")
              ?.classList.remove("bls-loading-image");
            e.currentTarget.classList.remove("bls-loading-image");
            resolve();
          });
        }
      });
    })
  );
};

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const autoHeight = _this?.dataset.autoHeight === "true";
    const paginationCustom = _this?.dataset.customPagination;
    const slideShow = _this?.dataset.slideshow === "true";
    const revealSlideshow = _this?.dataset.revealSlideshow === "true";
    const customNavigation = _this?.dataset.customNavigation === "true";
    const customPrev = _this?.dataset.customPrev;
    const customNext = _this?.dataset.customNext;
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      autoHeight: autoHeight,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      centeredSlides: false,
      grabCursor: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: customNavigation ? document.querySelector(`.${customNext}`) : _this.querySelector(".swiper-button-next"),
        prevEl: customNavigation ? document.querySelector(`.${customPrev}`) : _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: paginationCustom == undefined ? 
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination") : _this.querySelector(`.${paginationCustom}`),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: false
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: slideShow && itemDesktop == 1.5 ? true : false,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: "0px 0px -50px 0px" }
            );
          }

          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector("video.slideshow");
          if (video) {
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              const videos = _this.querySelectorAll("video");
              videos.forEach((video) => {
                const dataSrc = video.dataset.src;
                if (dataSrc) {
                  video.src = dataSrc;
                  video.removeAttribute("data-src");
                }
              });
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: "0px 0px 200px 0px",
            }).observe(_this);
          }
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
        slideChangeTransitionStart: function () {
          if (!slideShow) return;
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll("motion-element")
            .forEach(async (motion) => {
              await motion.preInitialize();
            });
        },
        slideChangeTransitionEnd: function () {
          if (!slideShow) return;
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll("motion-element")
            .forEach(async (motion) => {
                motion.classList.remove("animate-delay"),
                await motion.initialize();
            });
        },
        afterInit: function () {
          if (slideShow && revealSlideshow && itemDesktop <= 3) {
            _this.duplicateSlides(this);
          }
        },
        touchMove: function (swiper, event) {
          const innerWidth = event.view.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (slidePopup && swiperMedia && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = false;
            slidePopup.swiper.unsetGrabCursor();
          }
        },
        touchEnd: function (swiper, event) {
          const innerWidth = event.view.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (!swiperMedia) return;
          if (slidePopup && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = true;
            slidePopup.swiper.setGrabCursor();
          }
        }
      },
    });
  }

  duplicateSlides(swiper) {
    const _this = this;
    const swiperWrapper = _this.querySelector('.swiper-wrapper');
    const originalSlides = swiperWrapper.querySelectorAll('.swiper-slide');
    const paginationEl = _this.querySelector('.swiper-pagination');
    
    if (paginationEl) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && node.classList.contains('swiper-pagination-bullet')) {
                const allBullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
                const bulletIndex = Array.from(allBullets).indexOf(node);
                if (bulletIndex >= originalSlides.length) {
                  node.classList.add('swiper-pagination-duplicate');
                }
              }
            });
          }
        });
        observer.disconnect();
      });
      
      observer.observe(paginationEl, { childList: true });
    }
    
    originalSlides.forEach((slide) => {
        const clonedSlide = slide.cloneNode(true);
        clonedSlide.classList.add('swiper-slide-duplicate');
        swiperWrapper.appendChild(clonedSlide);
    });
    
    swiper.update();
  }

  initSecTiktok(sec) {
    sec.querySelectorAll(".swiper-slide").forEach((arrow) => {
      const tiktok = arrow.querySelector(".section_tiktok-image");
      let width = "--item-width: " + arrow.offsetWidth;
      tiktok.setAttribute("style", width);
    });
  }
}
customElements.define("slide-section", SlideSection);

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass, modalWidth) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const modalBoxContent = this.modal.querySelector(".tingle-modal-box");
        if (modalWidth) {
          modalBoxContent.style.setProperty("--popup-max-width", modalWidth);
        }
        document.dispatchEvent(new CustomEvent("modal:opened"));
        document.documentElement.classList.add("open-popup");
        root.style.setProperty(
          "padding-right",
          getScrollBarWidth.init() + "px"
        );
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        if (this.modal.classList.contains("shopable-video")) {
          video.muted = false;
        }
      },
      onClose: function () {
        document.dispatchEvent(new CustomEvent("modal:closed"));
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
      },
      beforeClose: function () {
        _this.onCloseEvent();
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {}
}

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this.init();
  }

  init() {
    const _this = this;
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } =
      e.dataset;
    if (color) {
      if (swatchType != "variant_images") {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
            if (image) {
              e.classList.add("color__" + color.replace(" ", "-"));
              e.style.backgroundColor = null;
              e.style.backgroundImage = "url('" + image + "')";
              e.style.backgroundSize = "cover";
              e.style.backgroundRepeat = "no-repeat";
            }
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      } else {
        if (optionSwatchValue == null || optionSwatchValue.length == 0) {
          if (image) {
            e.classList.add("color__" + color.replace(" ", "-"));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = "cover";
            e.style.backgroundRepeat = "no-repeat";
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (select) => select.getAttribute("data-value")
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const elementErrorMessage = html.querySelector(
        ".product-form__error-message-wrapper"
      );
      const elementMessage = elementErrorMessage.querySelector(
        ".product-form__error-message"
      );
      elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, "modal-error");
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(message, duration = 3000, customClass = "") {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  Motion.animate(
    toast,
    {
      opacity: [0, 1],
      scale: [0.3, 1],
    },
    {
      duration: 0.3,
      easing: "ease-out",
    }
  );

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  Motion.animate(
    toast,
    { opacity: 0, scale: 0.5 },
    { duration: 0.2, easing: "ease-in" }
  ).then(() => {
    toast.remove();
  });
}

class SlideLazyLoad {
  constructor(e) {
    (this.triggerEventsJs = e),
      (this.eventOptionsJs = { passive: !0 }),
      (this.userEventListenerJs = this.triggerListenerJs.bind(this)),
      (this.delayedScriptsJs = { normal: [], async: [], defer: [] });
  }
  triggerListenerJs() {
    this._removeUserInteractionListenerJs(this),
      "loading" === document.readyState
        ? document.addEventListener(
            "DOMContentLoaded",
            this._loadEverythingReadyNow.bind(this)
          )
        : this._loadEverythingReadyNow();
  }
  _removeUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _addUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _preloadAllScriptsJs() {
    document.body.classList.add("swiper-lazy");
    document.body.classList.add("review-lazy");
    const loadingSwiper = document.querySelectorAll(
      ".lazy-loading-swiper-after"
    );
    loadingSwiper.forEach((el) => {
      el.classList.remove("lazy-loading-swiper-after");
      this.initSlide(el);
    });
    const reviewProduct = document.querySelectorAll(".review-product-added");
    reviewProduct.forEach((el) => {
      el.classList.remove("review-product-added");
      el.innerHTML = el.querySelector(".product-review-json").innerHTML;
      el.classList.remove("inline-loading");
    });
  }

  initSlide(el) {
    const _this = el;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    _this.globalSlide = new Swiper(el, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el:
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          pagination: {
            type: progressbar ? "progressbar" : "bullets",
          },
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          pagination: {
            type: progressbar ? "progressbar" : "bullets",
          },
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: "0px 0px -50px 0px" }
            );
          }
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        },
        realIndexChange: function (swiper) {
          var slide_visibles = _this.querySelectorAll(
            ".swiper-slide motion-element:not([data-image])"
          );
          slide_visibles?.forEach((slide) => {
            if (!slide.hasAttribute("hold")) {
              slide?.setAttribute("hold", true);
            }
          });
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  async _loadEverythingReadyNow() {
    this._preloadAllScriptsJs(),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
      await this._triggerDOMContentLoadedJs(),
      await this._triggerWindowLoadJs(),
      window.dispatchEvent(new Event("glozinspeed-allScriptsLoaded"));
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift();
    return t
      ? (await this._transformScript(t), this._loadScriptsFromListJs(e))
      : Promise.resolve();
  }
  async _transformScript(e) {
    return (
      await this._requestAnimFrame(),
      new Promise((t) => {
        const s = document.createElement("script");
        let n;
        [...e.attributes].forEach((e) => {
          let t = e.nodeName;
          "type" !== t &&
            ("data-glozinlazy-type" === t && ((t = "type"), (n = e.nodeValue)),
            s.setAttribute(t, e.nodeValue));
        }),
          e.hasAttribute("src")
            ? (s.addEventListener("load", t), s.addEventListener("error", t))
            : ((s.text = e.text), t()),
          e.parentNode.replaceChild(s, e);
      })
    );
  }
  async _triggerDOMContentLoadedJs() {
    (this.domReadyFired = !0),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("glozinspeed-readystatechange")),
      await this._requestAnimFrame(),
      document.glozinonreadystatechange && document.glozinonreadystatechange();
  }
  async _triggerWindowLoadJs() {
    await this._requestAnimFrame(),
      window.dispatchEvent(new Event("glozinspeed-load")),
      await this._requestAnimFrame(),
      window.glozinonload && window.glozinonload(),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("glozinspeed-pageshow")),
      await this._requestAnimFrame(),
      window.glozinonpageshow && window.glozinonpageshow();
  }
  async _requestAnimFrame() {
    return new Promise((e) => requestAnimationFrame(e));
  }
  static run() {
    const e = new SlideLazyLoad([
      "keydown",
      "mousemove",
      "touchmove",
      "touchstart",
      "touchend",
      "wheel",
    ]);
    e._addUserInteractionListenerJs(e);
  }
}
SlideLazyLoad.run();

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add("copied");
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define("copy-button", CopyButton);


/* ==========================================================
   OLMÉRYS — MW VOLUME BUNDLE / QUANTITÉ LIBRE

   Quantité libre : 1, 2, 3, 4, 5, 6…
   Palier x1 : quantité 1
   Palier x2 : quantités 2 et 3
   Palier x4 : quantités 4 et plus

   MW envoie un tableau `items` contenant une ligne de
   quantité 1 par produit. Le correctif ajuste ce tableau
   à la quantité réellement choisie.
   ========================================================== */

(() => {
  if (window.__olmerysMwFreeQuantityLoaded) {
    return;
  }

  window.__olmerysMwFreeQuantityLoaded = true;

  const HOST_SELECTOR = 'mw-volume-bundle';
  const QUANTITY_SELECTOR = '[data-olmerys-quantity-input]';
  const MAIN_BUTTON_SELECTOR =
    '.product-detail__information [data-olmerys-add-button]';
  const STICKY_BUTTON_SELECTOR =
    'sticky-add-cart [data-olmerys-add-button]';
  const MAIN_PRICE_SELECTOR = '.product-detail__price';
  const MAX_QUANTITY = 99;
  const MONEY_REGEX = /\d[\d\s.]*(?:,\d{2}|\.\d{2})\s*€/;

  let currentHost = null;
  let currentShadowRoot = null;
  let shadowObserver = null;
  let documentObserver = null;
  let refreshFrame = null;
  let quantitySyncing = false;
  let programmaticTierClick = false;
  let manualTierClickSequence = 0;
  let allowNextMainClick = false;
  let requestedQuantity = null;

  function getHost() {
    return document.querySelector(HOST_SELECTOR);
  }

  function getShadowRoot() {
    return getHost()?.shadowRoot || null;
  }

  function parseQuantityFromTitle(value) {
    const match = String(value || '').match(/x\s*(\d+)/i);
    return match ? Number.parseInt(match[1], 10) : 0;
  }

  function parseMoneyToCents(value) {
    const matches = Array.from(
      String(value || '')
        .replace(/\u00a0/g, ' ')
        .matchAll(new RegExp(MONEY_REGEX.source, 'g'))
    );

    const match = matches[matches.length - 1];

    if (!match) {
      return null;
    }

    const amount = Number.parseFloat(
      match[0]
        .replace(/€/g, '')
        .replace(/\s/g, '')
        .replace(',', '.')
    );

    return Number.isFinite(amount)
      ? Math.round(amount * 100)
      : null;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function getChoices() {
    const root = getShadowRoot();

    if (!root) {
      return [];
    }

    return Array.from(
      root.querySelectorAll('.VolumeBundle label')
    )
      .map((label) => {
        const item = label.querySelector('.Item');
        const control = label.querySelector('.Item__ItemControl');
        const title = label.querySelector(
          '.Item__ItemTitle'
        )?.textContent;
        const priceText = label.querySelector(
          '.ItemPrice'
        )?.textContent;

        return {
          quantity: parseQuantityFromTitle(title),
          totalCents: parseMoneyToCents(priceText),
          label,
          item,
          control
        };
      })
      .filter((choice) => {
        return (
          choice.quantity > 0 &&
          Number.isFinite(choice.totalCents)
        );
      })
      .sort((a, b) => a.quantity - b.quantity);
  }

  function ensureBundleStockStyles() {
    const root = getShadowRoot();

    if (!root || root.getElementById('olmerys-mw-stock-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'olmerys-mw-stock-styles';
    style.textContent = `
      .VolumeBundle label.olmerys-bundle-stock-unavailable {
        cursor: not-allowed !important;
        opacity: 0.48 !important;
      }

      .VolumeBundle label.olmerys-bundle-stock-unavailable .Item,
      .VolumeBundle label.olmerys-bundle-stock-unavailable .Item.Item__Selected {
        background: #f5f5f3 !important;
        border-color: #d8d8d5 !important;
        box-shadow: none !important;
      }

      .VolumeBundle label.olmerys-bundle-stock-unavailable
      .Item__ItemTitle,
      .VolumeBundle label.olmerys-bundle-stock-unavailable
      .ItemPrice,
      .VolumeBundle label.olmerys-bundle-stock-unavailable
      .ItemPriceCompare {
        color: #8a8a86 !important;
      }

      .VolumeBundle label.olmerys-bundle-stock-unavailable
      .DiscountBadge {
        opacity: 0.55 !important;
        filter: grayscale(1);
      }
    `;

    root.appendChild(style);
  }

  function isChoiceAvailable(choice) {
    if (!choice) {
      return false;
    }

    return choice.quantity <= getMaximumPurchasableQuantity();
  }

  function updateBundleChoiceAvailability() {
    ensureBundleStockStyles();

    getChoices().forEach((choice) => {
      const available = isChoiceAvailable(choice);
      const unavailable = !available;
      const className = 'olmerys-bundle-stock-unavailable';

      choice.label.classList.toggle(className, unavailable);

      if (unavailable) {
        if (
          choice.label.getAttribute('aria-disabled') !== 'true'
        ) {
          choice.label.setAttribute('aria-disabled', 'true');
        }

        if (choice.label.getAttribute('tabindex') !== '-1') {
          choice.label.setAttribute('tabindex', '-1');
        }

        if (
          choice.control &&
          choice.control.dataset.olmerysStockDisabled !== 'true'
        ) {
          choice.control.dataset.olmerysStockWasDisabled =
            choice.control.disabled ? 'true' : 'false';
          choice.control.dataset.olmerysStockDisabled = 'true';
          choice.control.disabled = true;
        }
      } else {
        if (choice.label.hasAttribute('aria-disabled')) {
          choice.label.removeAttribute('aria-disabled');
        }

        if (choice.label.getAttribute('tabindex') === '-1') {
          choice.label.removeAttribute('tabindex');
        }

        if (
          choice.control?.dataset.olmerysStockDisabled === 'true'
        ) {
          const wasDisabled =
            choice.control.dataset.olmerysStockWasDisabled === 'true';

          if (!wasDisabled) {
            choice.control.disabled = false;
          }

          delete choice.control.dataset.olmerysStockDisabled;
          delete choice.control.dataset.olmerysStockWasDisabled;
        }
      }
    });
  }

  function getSelectedChoice() {
    return (
      getChoices().find((choice) => {
        return (
          choice.item?.classList.contains('Item__Selected') ||
          choice.control?.checked
        );
      }) || null
    );
  }

  function getTierForQuantity(quantity) {
    const choices = getChoices().filter(isChoiceAvailable);

    if (!choices.length) {
      return null;
    }

    let tier = choices[0];

    choices.forEach((choice) => {
      if (choice.quantity <= quantity) {
        tier = choice;
      }
    });

    return tier;
  }

  function parseInventoryLimit(value) {
    if (
      value === undefined ||
      value === null ||
      String(value).trim() === ''
    ) {
      return null;
    }

    const parsed = Number.parseInt(value, 10);

    if (!Number.isFinite(parsed) || parsed < 0) {
      return null;
    }

    return parsed;
  }

  function getInventoryLimitFromInput(input) {
    if (!input) {
      return null;
    }

    const inventoryLimit = parseInventoryLimit(
      input.dataset.inventoryMax
    );

    if (inventoryLimit !== null) {
      return inventoryLimit;
    }

    const ruleLimit = parseInventoryLimit(
      input.dataset.quantityRuleMax
    );

    if (ruleLimit !== null && ruleLimit > 0) {
      return ruleLimit;
    }

    const originalLimit = parseInventoryLimit(
      input.dataset.olmerysOriginalMax
    );

    if (originalLimit !== null) {
      return originalLimit;
    }

    return null;
  }

  function getSelectedVariantId() {
    const mainInput = getMainQuantityInput();

    const candidates = [
      mainInput?.form?.querySelector('[name="id"]'),
      document.querySelector(
        '[id^="MainProduct-"] form[action*="/cart/add"] [name="id"]'
      ),
      document.querySelector(
        '.product-detail__information form[action*="/cart/add"] [name="id"]'
      )
    ];

    for (const input of candidates) {
      const variantId = Number.parseInt(input?.value, 10);

      if (Number.isFinite(variantId) && variantId > 0) {
        return variantId;
      }
    }

    return 0;
  }

  function getSelectedVariantInventory() {
    const variantId = getSelectedVariantId();

    if (!variantId) {
      return null;
    }

    /*
     * Le thème fournit le stock de chaque déclinaison dans
     * .productVariantsQty. C'est la source fiable lorsqu'un
     * produit possède plusieurs variantes.
     */
    const jsonElements = Array.from(
      document.querySelectorAll('.productVariantsQty')
    );

    for (const jsonElement of jsonElements) {
      try {
        const variants = JSON.parse(
          jsonElement.textContent || '[]'
        );

        const variant = Array.isArray(variants)
          ? variants.find(
              (item) => Number(item?.id) === variantId
            )
          : null;

        if (!variant) {
          continue;
        }

        const management =
          variant.mamagement ??
          variant.management ??
          null;

        /*
         * Sans suivi de stock Shopify, on ne bloque pas
         * artificiellement les offres x2 ou x4.
         */
        if (management === '' || management == null) {
          return {
            tracked: false,
            quantity: null
          };
        }

        const quantity = Number.parseInt(
          variant.qty,
          10
        );

        return {
          tracked: true,
          quantity: Number.isFinite(quantity)
            ? Math.max(0, quantity)
            : 0
        };
      } catch (error) {
        console.warn(
          'OLMÉRYS : lecture du stock des déclinaisons impossible.',
          error
        );
      }
    }

    return null;
  }

  function getQuantityRuleMaximum() {
    const limits = getQuantityInputs()
      .map((input) =>
        parseInventoryLimit(
          input.dataset.quantityRuleMax
        )
      )
      .filter(
        (value) =>
          value !== null &&
          value > 0
      );

    return limits.length
      ? Math.min(...limits)
      : null;
  }

  function getMaximumPurchasableQuantity() {
    const variantInventory =
      getSelectedVariantInventory();

    const ruleMaximum =
      getQuantityRuleMaximum();

    /*
     * Priorité au stock de la déclinaison actuellement choisie.
     * Cela évite de conserver data-inventory-max="2" après
     * le passage vers une autre déclinaison ayant 5 unités.
     */
    if (
      variantInventory?.tracked &&
      Number.isFinite(
        variantInventory.quantity
      )
    ) {
      const candidates = [
        variantInventory.quantity,
        MAX_QUANTITY
      ];

      if (ruleMaximum !== null) {
        candidates.push(ruleMaximum);
      }

      return Math.min(...candidates);
    }

    if (variantInventory?.tracked === false) {
      return ruleMaximum !== null
        ? Math.min(
            ruleMaximum,
            MAX_QUANTITY
          )
        : MAX_QUANTITY;
    }

    /*
     * Repli pour les produits sans JSON de variantes.
     */
    const mainInput = getMainQuantityInput();
    const mainLimit =
      getInventoryLimitFromInput(mainInput);

    if (mainLimit !== null) {
      return Math.min(
        mainLimit,
        MAX_QUANTITY
      );
    }

    for (const input of getQuantityInputs()) {
      const limit =
        getInventoryLimitFromInput(input);

      if (limit !== null) {
        return Math.min(
          limit,
          MAX_QUANTITY
        );
      }
    }

    return MAX_QUANTITY;
  }

  function normalizeQuantity(value) {
    const parsed = Number.parseInt(value, 10);
    const stockMaximum = getMaximumPurchasableQuantity();
    const maximum = Math.max(1, stockMaximum);

    if (!Number.isFinite(parsed)) {
      return 1;
    }

    return Math.max(1, Math.min(parsed, maximum));
  }

  function getQuantityInputs() {
    return Array.from(
      document.querySelectorAll(QUANTITY_SELECTOR)
    );
  }

  function isUsableElement(element) {
    if (!element || !element.isConnected) {
      return false;
    }

    const style = window.getComputedStyle(element);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      element.getClientRects().length > 0
    );
  }

  function getMainQuantityInput() {
    const inputs = getQuantityInputs();
    const mainInputs = inputs.filter(
      (input) => !input.closest('sticky-add-cart')
    );

    return (
      mainInputs.find(isUsableElement) ||
      mainInputs.find(
        (input) =>
          String(input.form?.id || '').startsWith('product-form-')
      ) ||
      inputs.find(isUsableElement) ||
      mainInputs[0] ||
      inputs[0] ||
      null
    );
  }

  function getCurrentQuantity() {
    if (Number.isFinite(requestedQuantity)) {
      return normalizeQuantity(requestedQuantity);
    }

    return normalizeQuantity(getMainQuantityInput()?.value || 1);
  }

  function updateQuantityButtons(input, quantity) {
    const wrapper = input.closest('quantity-input');

    if (!wrapper) {
      return;
    }

    const minus = wrapper.querySelector('[name="minus"]');
    const plus = wrapper.querySelector('[name="plus"]');
    const maximum = Math.max(1, getMaximumPurchasableQuantity());
    const minusDisabled = quantity <= 1;
    const plusDisabled = quantity >= maximum;

    if (minus) {
      minus.disabled = minusDisabled;
      minus.classList.toggle('disabled', minusDisabled);
      minus.setAttribute(
        'aria-disabled',
        minusDisabled ? 'true' : 'false'
      );
    }

    if (plus) {
      plus.disabled = plusDisabled;
      plus.classList.toggle('disabled', plusDisabled);
      plus.setAttribute(
        'aria-disabled',
        plusDisabled ? 'true' : 'false'
      );
    }
  }

  function prepareQuantityInputs() {
    const maximum = Math.max(1, getMaximumPurchasableQuantity());

    if (Number.isFinite(requestedQuantity)) {
      requestedQuantity = normalizeQuantity(requestedQuantity);
    }

    getQuantityInputs().forEach((input) => {
      if (!input.dataset.olmerysOriginalMax) {
        input.dataset.olmerysOriginalMax =
          input.getAttribute('max') || '';
      }

      input.min = '1';
      input.max = String(maximum);
      input.step = '1';

      const quantity = normalizeQuantity(input.value);

      if (String(input.value) !== String(quantity)) {
        input.value = String(quantity);
      }

      updateQuantityButtons(input, quantity);
    });

    updateBundleChoiceAvailability();
  }

  function setQuantityEverywhere(value) {
    const quantity = normalizeQuantity(value);

    requestedQuantity = quantity;
    quantitySyncing = true;
    prepareQuantityInputs();

    getQuantityInputs().forEach((input) => {
      input.value = String(quantity);
      updateQuantityButtons(input, quantity);
    });

    quantitySyncing = false;
    return quantity;
  }

  function clickTierChoice(choice) {
    if (!choice || !isChoiceAvailable(choice)) {
      updateBundleChoiceAvailability();
      return false;
    }

    programmaticTierClick = true;

    try {
      if (choice.control && !choice.control.disabled) {
        choice.control.click();
      } else {
        choice.label.click();
      }
    } finally {
      programmaticTierClick = false;
    }

    return true;
  }

  function selectTierForQuantity(quantity) {
    const tier = getTierForQuantity(quantity);
    const selected = getSelectedChoice();

    if (!tier || selected?.quantity === tier.quantity) {
      return false;
    }

    return clickTierChoice(tier);
  }

  function getTotalCents(quantity) {
    const tier = getTierForQuantity(quantity);

    if (!tier || !tier.quantity) {
      return null;
    }

    return Math.round(
      (tier.totalCents * quantity) / tier.quantity
    );
  }

  function findPriceElementInBox(box) {
    if (!box) {
      return null;
    }

    const selectors = [
      '.price.price-same-style',
      '.price__sale .price-item--sale',
      '.price-item--sale',
      '[data-product-price]',
      '[data-current-price]',
      '.price__regular .price-item--regular',
      '.price-item--regular',
      '.price'
    ];

    for (const selector of selectors) {
      const element = box.querySelector(selector);

      if (
        element &&
        MONEY_REGEX.test(element.textContent || '')
      ) {
        return element;
      }
    }

    return null;
  }

  function getMainPriceElements() {
    const elements = Array.from(
      document.querySelectorAll(MAIN_PRICE_SELECTOR)
    )
      .map(findPriceElementInBox)
      .filter(Boolean);

    return Array.from(new Set(elements));
  }

  function updateMainPrice(formattedTotal) {
    getMainPriceElements().forEach((element) => {
      window.clearTimeout(element._olmerysPriceSwapTimer);
      window.clearTimeout(element._olmerysPriceEndTimer);

      /*
       * Un remplacement de section pouvait laisser la classe
       * de transition active et donc le prix grisé.
       */
      element.classList.remove('olmerys-price-changing');
      delete element.dataset.olmerysPendingPrice;

      const current = String(element.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();
      const next = String(formattedTotal || '')
        .replace(/\s+/g, ' ')
        .trim();

      if (current !== next) {
        element.textContent = formattedTotal;
      }
    });
  }

  function cleanButtonLabel(value) {
    return (
      String(value || '')
        .replace(/\s+/g, ' ')
        .replace(
          /\s*[—–-]\s*\d[\d\s.]*(?:,\d{2}|\.\d{2})\s*€\s*$/i,
          ''
        )
        .trim() || 'Ajouter au panier'
    );
  }

  function updateButton(button, formattedTotal) {
    const label = button?.querySelector('.btn-label');

    if (!label) {
      return;
    }

    const current = label.textContent
      .replace(/\s+/g, ' ')
      .trim();

    if (
      /épuisé|rupture|indisponible|précommande|sold out|unavailable/i.test(
        current
      )
    ) {
      return;
    }

    if (!label.dataset.olmerysVolumeBaseLabel) {
      label.dataset.olmerysVolumeBaseLabel =
        cleanButtonLabel(current);
    }

    const next =
      `${label.dataset.olmerysVolumeBaseLabel} — ${formattedTotal}`;

    if (current !== next) {
      label.textContent = next;
    }
  }

  function refreshDisplay() {
    refreshFrame = null;
    prepareQuantityInputs();

    const quantity = getCurrentQuantity();

    updateBundleChoiceAvailability();
    selectTierForQuantity(quantity);

    const totalCents = getTotalCents(quantity);

    if (!Number.isFinite(totalCents)) {
      return;
    }

    const formattedTotal = formatMoney(totalCents);

    updateMainPrice(formattedTotal);

    document
      .querySelectorAll(MAIN_BUTTON_SELECTOR)
      .forEach((button) => {
        updateButton(button, formattedTotal);
      });

    document
      .querySelectorAll(STICKY_BUTTON_SELECTOR)
      .forEach((button) => {
        updateButton(button, formattedTotal);
      });
  }

  function scheduleRefresh() {
    if (refreshFrame !== null) {
      return;
    }

    refreshFrame = window.requestAnimationFrame(refreshDisplay);
  }

  function refreshSeveralTimes() {
    scheduleRefresh();
    window.setTimeout(scheduleRefresh, 80);
    window.setTimeout(scheduleRefresh, 180);
    window.setTimeout(scheduleRefresh, 350);
  }

  function synchronizeFromQuantity(value) {
    const quantity = setQuantityEverywhere(value);
    selectTierForQuantity(quantity);
    refreshSeveralTimes();
  }

  function handleQuantityChange(event) {
    const input =
      event.target instanceof Element &&
      event.target.matches(QUANTITY_SELECTOR)
        ? event.target
        : null;

    if (!input || quantitySyncing || !getShadowRoot()) {
      return;
    }

    requestedQuantity = normalizeQuantity(input.value);
    synchronizeFromQuantity(requestedQuantity);
  }

  function synchronizeFromManualTier(choice) {
    if (!choice || !isChoiceAvailable(choice)) {
      updateBundleChoiceAvailability();
      return;
    }

    const sequence = ++manualTierClickSequence;
    const quantity = choice.quantity;

    /*
     * Le clic manuel devient immédiatement la source de vérité.
     * Cela évite qu’un ancien clic retardé sur x1, x2 ou x4
     * reprenne la main lorsque le client clique rapidement.
     */
    requestedQuantity = quantity;
    setQuantityEverywhere(quantity);
    refreshSeveralTimes();

    /*
     * On laisse d’abord MW terminer son clic naturel.
     * Un seul contrôle tardif évite le double-clic automatique
     * qui provoquait le petit flash sur les prix des offres.
     */
    window.setTimeout(() => {
      if (sequence !== manualTierClickSequence) {
        return;
      }

      const selected = getSelectedChoice();

      /*
       * Correction de secours uniquement si MW n’a vraiment
       * pas conservé le dernier choix après sa mise à jour.
       */
      if (selected?.quantity !== quantity) {
        clickTierChoice(choice);
      }

      setQuantityEverywhere(quantity);
      scheduleRefresh();
    }, 220);
  }

  function synchronizeStickyForm(stickyButton, mainButton) {
    const stickyForm = stickyButton.closest(
      'form[action*="/cart/add"]'
    );
    const mainForm = mainButton.closest(
      'form[action*="/cart/add"]'
    );

    if (!stickyForm || !mainForm) {
      return;
    }

    const stickyVariant = stickyForm.querySelector('[name="id"]');
    const mainVariant = mainForm.querySelector('[name="id"]');
    const stickyQuantity = stickyForm.querySelector(
      '[name="quantity"]'
    );
    const mainQuantity = mainForm.querySelector(
      '[name="quantity"]'
    );

    if (stickyVariant?.value && mainVariant) {
      mainVariant.disabled = false;
      mainVariant.value = stickyVariant.value;
    }

    if (stickyQuantity?.value && mainQuantity) {
      mainQuantity.value = stickyQuantity.value;
    }
  }

  function replayMainClick(mainButton, delay = 0) {
    window.setTimeout(() => {
      allowNextMainClick = true;
      mainButton.click();
    }, delay);
  }

  function stopClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function handleAddButtonClick(event) {
    const target =
      event.target instanceof Element ? event.target : null;

    if (!target || !getShadowRoot()) {
      return;
    }

    const mainButton = target.closest(MAIN_BUTTON_SELECTOR);
    const stickyButton = target.closest(STICKY_BUTTON_SELECTOR);

    if (!mainButton && !stickyButton) {
      return;
    }

    if (mainButton && allowNextMainClick) {
      allowNextMainClick = false;
      return;
    }

    const realMainButton =
      mainButton || document.querySelector(MAIN_BUTTON_SELECTOR);

    if (
      !realMainButton ||
      realMainButton.disabled ||
      realMainButton.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    const quantity = getCurrentQuantity();
    const requiredTier = getTierForQuantity(quantity);
    const selectedTier = getSelectedChoice();
    const tierMustChange =
      requiredTier &&
      selectedTier?.quantity !== requiredTier.quantity;

    if (stickyButton) {
      stopClick(event);
      synchronizeStickyForm(stickyButton, realMainButton);

      if (tierMustChange) {
        selectTierForQuantity(quantity);
        replayMainClick(realMainButton, 140);
      } else {
        replayMainClick(realMainButton);
      }

      return;
    }

    if (tierMustChange) {
      stopClick(event);
      selectTierForQuantity(quantity);
      replayMainClick(realMainButton, 140);
    }
  }

  function cloneItem(item) {
    return JSON.parse(JSON.stringify(item));
  }

  function resizeItems(items, desiredQuantity) {
    if (!Array.isArray(items) || !items.length) {
      return items;
    }

    const result = [];

    for (let index = 0; index < desiredQuantity; index += 1) {
      const source = items[index % items.length];
      const copy = cloneItem(source);
      copy.quantity = 1;
      result.push(copy);
    }

    return result;
  }

  function transformJsonCartBody(bodyText) {
    try {
      const data = JSON.parse(bodyText);

      if (!Array.isArray(data?.items) || !data.items.length) {
        return bodyText;
      }

      data.items = resizeItems(
        data.items,
        Math.min(
          getCurrentQuantity(),
          Math.max(1, getMaximumPurchasableQuantity())
        )
      );

      return JSON.stringify(data);
    } catch {
      return bodyText;
    }
  }

  function isMwCartAddUrl(value) {
    const url = String(value || '');

    return (
      url.includes('/cart/add') &&
      url.includes('app=mwsmoffers')
    );
  }

  function installFetchBridge() {
    if (window.__olmerysMwFreeQuantityFetchInstalled) {
      return;
    }

    window.__olmerysMwFreeQuantityFetchInstalled = true;

    const originalFetch = window.fetch.bind(window);

    window.fetch = async function patchedOlmerysFetch(
      input,
      init
    ) {
      const url =
        typeof input === 'string'
          ? input
          : input?.url || '';

      if (!isMwCartAddUrl(url)) {
        return originalFetch(input, init);
      }

      const nextInit = init ? { ...init } : {};

      if (typeof nextInit.body === 'string') {
        nextInit.body = transformJsonCartBody(nextInit.body);
        return originalFetch(input, nextInit);
      }

      if (input instanceof Request && !nextInit.body) {
        try {
          const requestClone = input.clone();
          const contentType =
            requestClone.headers.get('content-type') || '';

          if (contentType.includes('application/json')) {
            const originalBody = await requestClone.text();
            const nextBody = transformJsonCartBody(originalBody);
            const nextRequest = new Request(input, {
              body: nextBody
            });

            return originalFetch(nextRequest, nextInit);
          }
        } catch (error) {
          console.warn(
            'OLMÉRYS : impossible d’ajuster la quantité MW.',
            error
          );
        }
      }

      return originalFetch(input, nextInit);
    };
  }

  function connectShadowRoot() {
    const host = getHost();
    const root = host?.shadowRoot;

    if (!host || !root) {
      return false;
    }

    prepareQuantityInputs();
    updateBundleChoiceAvailability();

    if (
      currentHost === host &&
      currentShadowRoot === root
    ) {
      selectTierForQuantity(getCurrentQuantity());
      scheduleRefresh();
      return true;
    }

    shadowObserver?.disconnect();
    currentHost = host;
    currentShadowRoot = root;

    root.addEventListener(
      'click',
      (event) => {
        const target =
          event.target instanceof Element ? event.target : null;
        const label = target?.closest('.VolumeBundle label');

        if (!label) {
          return;
        }

        const choice = getChoices().find(
          (item) => item.label === label
        );

        if (!choice) {
          return;
        }

        if (!isChoiceAvailable(choice)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          updateBundleChoiceAvailability();
          return;
        }

        /*
         * Un clic déclenché par le script sert seulement à
         * appliquer un palier. Un véritable clic client doit
         * toujours être accepté immédiatement.
         */
        if (programmaticTierClick) {
          scheduleRefresh();
          return;
        }

        synchronizeFromManualTier(choice);
      },
      true
    );

    root.addEventListener(
      'change',
      () => {
        refreshSeveralTimes();
      },
      true
    );

    shadowObserver = new MutationObserver(() => {
      prepareQuantityInputs();
      updateBundleChoiceAvailability();
      scheduleRefresh();
    });

    shadowObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
      attributeFilter: ['class', 'checked']
    });

    selectTierForQuantity(getCurrentQuantity());
    refreshSeveralTimes();
    return true;
  }

  function handleVariantInventoryChange(event) {
    const target =
      event.target instanceof Element
        ? event.target
        : null;

    if (
      !target ||
      target.matches(QUANTITY_SELECTOR)
    ) {
      return;
    }

    const variantPicker = target.closest(
      [
        'variant-radios-detail',
        'variant-group-detail',
        'variant-selects',
        'variant-radios',
        '.product-detail__variant-picker'
      ].join(',')
    );

    if (!variantPicker) {
      return;
    }

    const desiredQuantity =
      Number.parseInt(
        getMainQuantityInput()?.value,
        10
      ) || 1;

    /*
     * Le thème met à jour l'identifiant de variante et son
     * compteur de stock juste après l'événement change.
     */
    [0, 80, 220].forEach((delay) => {
      window.setTimeout(() => {
        requestedQuantity =
          normalizeQuantity(
            desiredQuantity
          );

        setQuantityEverywhere(
          requestedQuantity
        );

        updateBundleChoiceAvailability();
        selectTierForQuantity(
          requestedQuantity
        );
        scheduleRefresh();
      }, delay);
    });
  }

  function initialize() {
    const initialInput = getMainQuantityInput();

    if (initialInput) {
      requestedQuantity = normalizeQuantity(initialInput.value);
    }

    installFetchBridge();
    connectShadowRoot();

    document.addEventListener(
      'change',
      handleQuantityChange,
      true
    );

    document.addEventListener(
      'change',
      handleVariantInventoryChange,
      true
    );

    document.addEventListener(
      'click',
      handleAddButtonClick,
      true
    );

    documentObserver = new MutationObserver(() => {
      connectShadowRoot();
      prepareQuantityInputs();
      scheduleRefresh();
    });

    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(connectShadowRoot, 300);
    window.setTimeout(connectShadowRoot, 1000);
    window.setTimeout(connectShadowRoot, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once: true
    });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(connectShadowRoot, 100);
  });
})();
